export default __webpack_public_path__ + "static/media/artgallery.996e9bff.png";